export const MAX_DATE: Date = new Date('2999');
